import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { PopOver, usePopOver } from '@xingternal/pop-over';
import { IconInfo, IconCross } from '@xingternal/icons';
import { TextButton } from '@xingternal/button';

import { EditContext, PageContext } from '@xingternal/pages-common';

import styles from './TitleTooltip.css';

const TitleTooltip = () => {
  const popOver = usePopOver();
  const { isEditing, isAdmin } = useContext(EditContext);
  const { pageContext } = useContext(PageContext);
  const isFreePage = pageContext?.contractType === 'FREE';

  const displayTitleInfo =
    pageContext?.focusType === 'COMPANY' && isAdmin && isEditing;

  return displayTitleInfo ? (
    <div className={styles.container}>
      <TextButton
        onClick={popOver.handleShow}
        className={styles.iconWrapper}
        innerRef={popOver.triggerRef}
        aria-label="Info"
      >
        <IconInfo width={16} height={16} />
      </TextButton>
      <PopOver
        onOutsideClick={popOver.handleHide}
        triggerRef={popOver.triggerRef}
        show={popOver.show}
        className={styles.popOver}
      >
        <>
          <TextButton
            className={styles.popOverCloseCTA}
            size={'small'}
            onClick={popOver.handleHide}
            aria-label="Cross"
          >
            <IconCross width={20} height={20} />
          </TextButton>
          <span className={styles.noticeWrapper}>
            <FormattedMessage
              id={
                isFreePage
                  ? 'EP_CHANGE_TITLE_INFO_FREE_V2'
                  : 'EP_CHANGE_TITLE_INFO_V2'
              }
              defaultMessage={
                isFreePage
                  ? 'EP_CHANGE_TITLE_INFO_FREE_V2'
                  : 'EP_CHANGE_TITLE_INFO_V2'
              }
              values={{
                a: (b: any) => <a href={'mailto:' + b}>{b}</a>,
              }}
            />
          </span>
        </>
      </PopOver>
    </div>
  ) : null;
};

export default TitleTooltip;
